import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "small-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tx_loading = _resolveComponent("tx-loading")!
  const _component_create_red_pack = _resolveComponent("create-red-pack")!
  const _component_success = _resolveComponent("success")!
  const _component_err_c = _resolveComponent("err-c")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_tx_loading, {
          key: 0,
          title: `Your Claim: ${_ctx.butQuantityVal}`
        }, null, 8, ["title"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.createStep === 'create')
            ? (_openBlock(), _createBlock(_component_create_red_pack, {
                key: 0,
                address: _ctx.addressInit,
                balance: _ctx.balanceInit,
                tokenInfo: _ctx.tokenInfoInit,
                chainId: _ctx.chainIdInit,
                provider: _ctx.provider,
                sendLoading: _ctx.sendLoading,
                redPackContractAddr: _ctx.redPackContractAddrInit,
                maxButQuantity: _ctx.maxButQuantity,
                onSendNftBuy: _ctx.nftBuyHandler,
                onConnect: _ctx.connectHandler
              }, null, 8, ["address", "balance", "tokenInfo", "chainId", "provider", "sendLoading", "redPackContractAddr", "maxButQuantity", "onSendNftBuy", "onConnect"]))
            : (_ctx.createStep === 'success')
              ? (_openBlock(), _createBlock(_component_success, {
                  key: 1,
                  butQuantity: _ctx.butQuantityVal
                }, null, 8, ["butQuantity"]))
              : (_ctx.createStep === 'err')
                ? (_openBlock(), _createBlock(_component_err_c, {
                    key: 2,
                    onRetry: _ctx.retryHandler
                  }, null, 8, ["onRetry"]))
                : _createCommentVNode("", true)
        ], 64))
  ]))
}